import { render, staticRenderFns } from "./Detail-role.vue?vue&type=template&id=ee92f794&scoped=true"
import script from "./Detail-role.vue?vue&type=script&lang=js"
export * from "./Detail-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee92f794",
  null
  
)

export default component.exports